import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';
import { PlessViewUtilsSub } from 'src/app/commons/kymw00/pless-view-utils-sub.service';

export const kymw9009Handlers = [

  // ユーザ階層管理取得 /kymw90/getUserClassManagementList
  http.post(PlessService.SERVICE.getUserClassManagementList.url, async ({ request }) => {
    const req: any = await request.json();

    // パラメータの部門コード取得
    const classCode = req.data.search.GetUserClassManagementList.condition.ClassCode;

    let data = [];

    if (classCode == "") {
      data = [
        ['10', '部門10', 'gUser10', 'グループ長 10', 'sUser10', '担当者 10', 'aUser10', '代行者 10'],
        ['10', '部門10', 'gUser11', 'グループ長 11', 'sUser11', '担当者 11', 'aUser11', '代行者 11'],
        ['10', '部門10', 'gUser11', 'グループ長 11', 'sUser12', '担当者 12', 'aUser12', '代行者 12'],
        ['20', '部門20', 'gUser20', 'グループ長 20', 'sUser20', '担当者 20', 'aUser20', '代行者 20'],
        ['30', '部門30', 'gUser30', 'グループ長 30', 'sUser30', '担当者 30', 'aUser30', '代行者 30'],
      ];

    } else if (classCode == "01") {
      data = [
        ['1', '部門1', 'gUser11', 'グループ長 11', 'sUser111', '担当者 111', 'aUser111AA', '代行者 AA'],
        ['1', '部門1', 'gUser11', 'グループ長 11', 'sUser111', '担当者 111', 'aUser111BB', '代行者 BB'],
        ['1', '部門1', 'gUser11', 'グループ長 11', 'sUser112', '担当者 112', 'aUser112CC', '代行者 CC'],
        ['1', '部門1', 'gUser11', 'グループ長 11', 'sUser112', '担当者 112', 'aUser112DD', '代行者 DD'],

        ['1', '部門1', 'gUser12', 'グループ長 12', 'sUser121', '担当者 121', 'aUser121EE', '代行者 EE'],
        ['1', '部門1', 'gUser12', 'グループ長 12', 'sUser121', '担当者 121', 'aUser121FF', '代行者 FF'],
        ['1', '部門1', 'gUser12', 'グループ長 12', 'sUser122', '担当者 122', 'aUser122GG', '代行者 GG'],
        ['1', '部門1', 'gUser12', 'グループ長 12', 'sUser122', '担当者 122', 'aUser122HH', '代行者 HH'],

        ['1', '部門1', 'gUser13', 'グループ長 13', 'sUser131', '担当者 131', 'aUser131II', '代行者 II'],
        ['1', '部門1', 'gUser13', 'グループ長 13', 'sUser131', '担当者 131', 'aUser131JJ', '代行者 JJ'],
        ['1', '部門1', 'gUser13', 'グループ長 13', 'sUser132', '担当者 132', 'aUser132KK', '代行者 KK'],
        ['1', '部門1', 'gUser13', 'グループ長 13', 'sUser132', '担当者 132', 'aUser132LL', '代行者 LL'],

        ['2', '部門2', 'gUser21', 'グループ長 21', 'sUser211', '担当者 211', 'aUser211MM', '代行者 MM'],
        ['2', '部門2', 'gUser21', 'グループ長 21', 'sUser212', '担当者 212', 'aUser212NN', '代行者 NN'],
        ['2', '部門2', 'gUser22', 'グループ長 22', 'sUser221', '担当者 221', 'aUser221OO', '代行者 OO'],

        ['3', '部門3', 'gUser31', 'グループ長 31', 'sUser311', '担当者 311', 'aUser311PP', '代行者 PP'],
        ['4', '部門4', 'gUser41', 'グループ長 41', 'sUser411', '担当者 411', null, null],
        ['5', '部門5', 'gUser51', 'グループ長 51', null, null, null, null],
        ['6', '部門6', null, null, null, null, null, null], 
      ];

    } else if (classCode == "19") {
      data = [
        ['19', 'ドラッグ', 'gUser001', 'グループ長 001', 'sUser001', '担当者 001', 'aUser001', '代行者 001'],
        ['19', 'ドラッグ', 'gUser002', 'グループ長 002', 'sUser002', '担当者 002', null, null],
        ['19', 'ドラッグ', 'gUser003', 'グループ長 003', null, null, null, null],
        ['19', 'ドラッグ', null, null, null, null, null, null], 
      ];
      
    } else if (classCode == "41") {
      data = [
        ['1', '部門1', null, null, null, null, null, null],
      ];
      
    } else if (classCode == "45") {
      data = [
        ['1', '部門1', null, null, null, null, null, null],
        ['2', '部門2', 'gUser21', 'グループ長 21', null, null, null, null],
      ];
      
    } else if (classCode == "61") {
      data = [
        ['1', 'とうきょう特別１', null, null, null, null, null, null],
        ['2', '部門2', 'gUser21', 'グループ長 21', null, null, null, null],
        ['3', '部門3', 'gUser31', 'グループ長 31', 'sUser311', '担当者 311', null, null],
      ];
      
    } else if (classCode == "65") {
      data = [
        ['1', '部門1', null, null, null, null, null, null],
        ['2', '部門2', 'gUser21', 'グループ長 21', null, null, null, null],
        ['3', '部門3', 'gUser31', 'グループ長 31', 'sUser311', '担当者 311', null, null],
        ['4', '部門4', 'gUser41', 'グループ長 41', 'sUser411', '担当者 411', 'aUser411QQ', '代行者 QQ'],
      ];
      
    } else if (classCode == "68") {
      data = [
        ['4', '部門4', 'gUser41', 'グループ長 41', 'sUser411', '担当者 411', 'aUser411QQ', '代行者 QQ'],
      ];
      
    } else if (classCode == "70") {
      data = [
        ['4', '部門4', 'gUser41', 'グループ長 41', 'sUser411', '担当者 411', 'aUser411QQ', '代行者 QQ'],
        ['3', '部門3', 'gUser31', 'グループ長 31', 'sUser311', '担当者 311', null, null],
      ];
      
    } else if (classCode == "76") {
      data = [
        ['4', '部門4', 'gUser41', 'グループ長 41', 'sUser411', '担当者 411', 'aUser411QQ', '代行者 QQ'],
        ['3', '部門3', 'gUser31', 'グループ長 31', 'sUser311', '担当者 311', null, null],
        ['2', '部門2', 'gUser21', 'グループ長 21', null, null, null, null],
      ];
      
    } else if (classCode == "79") {
      data = [
        ['4', '部門4', 'gUser41', 'グループ長 41', 'sUser411', '担当者 411', 'aUser411QQ', '代行者 QQ'],
        ['3', '部門3', 'gUser31', 'グループ長 31', 'sUser311', '担当者 311', null, null],
        ['2', '部門2', 'gUser21', 'グループ長 21', null, null, null, null],
        ['1', '部門1', null, null, null, null, null, null],
      ];
      
    } else if (classCode == "94") {
      data = [
        ['1', 'その他（セット商品）', null, null, null, null, null, null],
        ['2', '部門2', 'gUser21', 'グループ長 21', null, null, null, null],
        ['3', '部門3', 'gUser31', 'グループ長 31', 'sUser311', '担当者 311', null, null],
        ['4', '部門4', 'gUser41', 'グループ長 41', 'sUser411', '担当者 411', 'aUser411QQ', '代行者 QQ'],
        ['5', '部門5', 'gUser51', 'グループ長 51', 'sUser511', '担当者 511', null, null],
        ['6', '部門6', 'gUser61', 'グループ長 61', null, null, null, null], 
        ['7', '部門7', null, null, null, null, null, null], 
      ];
      
    } else if (classCode == "97") {
      data = [
        ['1', '部門1', null, null, null, null, null, null],
        ['2', '部門2', null, null, null, null, null, null],
        ['3', '部門3', null, null, null, null, null, null],
        ['4', '部門4', null, null, null, null, null, null],
        ['5', '部門5', null, null, null, null, null, null],
        ['6', '部門6', null, null, null, null, null, null], 
      ];

    } else if (classCode == "98") {
      data = [];

    } else if (classCode == "21") {
      return HttpResponse.json(makeSystemError());
    } else if (classCode == "22") {
      return HttpResponse.json(makeSessionError());
    }

    return HttpResponse.json(makeGetUserClassManagementListResponse(data));
  }),
  
  // Okta情報取得 /kymw90/getOktaInfomationList
  http.post(PlessService.SERVICE.getOktaInfomationList.url, async ({ request }) => {
    const req: any = await request.json();

    // パラメータの部門コード取得
    const userNmKanji = req.data.search.GetOktaInfomationList.condition.UserNmKanji;

    if (userNmKanji === 'システムエラー') {
      return HttpResponse.json(makeSystemError());
    } else
    if (userNmKanji === 'セッションエラー') {
      return HttpResponse.json(makeSessionError());
    }

    return HttpResponse.json(makeOktaInfomationListResponse(userNmKanji));
  }),

  // ユーザ階層管理更新 /kymw90/updateUserClassManagement
  http.post(PlessService.SERVICE.updateUserClassManagement.url, async ({ request }) => {
    const req: any = await request.json();
    console.log('----- [update] request body json -----');
    console.log(req);

    let params = req.data.update.UpdateUserClassManagementList.combination;

    return HttpResponse.json(makeUpdateUserClassManagementResponse(params));
  }),

  // ユーザ階層管理削除 /kymw90/deleteUserClassManagement
  http.post(PlessService.SERVICE.deleteUserClassManagement.url, async ({ request }) => {
    const req: any = await request.json();
    console.log('----- [delete] request body json -----');
    console.log(req);

    let params = req.data.delete.DeleteUserClassManagementList.combination;

    return HttpResponse.json(makeDeleteUserClassManagementResponse(params));
  }),

  // Oktaユーザ名取得 /kymw90/getOktaUserName
  http.post(PlessService.SERVICE.getOktaUserName.url, async ({ request }) => {
    const req: any = await request.json();

    // パラメータのユーザID取得
    const userId = req.data.search.GetOktaUserName.condition.UserId;

    if (userId === 'sysErr99') {
      return HttpResponse.json(makeSystemError());
    }
    if (userId === 'sesErr99') {
      return HttpResponse.json(makeSessionError());
    }

    let data: string = '';
    if (userId.length > 6) {
      let pre = userId.slice(0, 5);
      let suf = userId.slice(5);

      if (pre == "gUser") {
        data = 'グループ長 ' + suf;
      } else if (pre == "sUser") {
        data = '担当者 ' + suf;
      } else if (pre == "aUser") {
        data = '代行者 ' + suf;
      } else {
        data = '';
      }

    } else {
      data = null;
    }

    return HttpResponse.json(makeGetOktaUserNameResponse(data));
  }),

];

const makeGetUserClassManagementListResponse = (data: Array<any>): object => {

  const response = {
    status: 'ok',
    message: '処理完了',
    result: {
      obj: {
        UserClassManagementList: [],
      },
    },
  };

  data.forEach((d) => {
    let elm = {
      ClassCode: d[0], ClassName: d[1],
      GroupLeaderUserId: d[2], GroupLeaderUserName: d[3],
      StaffUserId: d[4], StaffUserName: d[5],
      AgentUserId: d[6], AgentUserName: d[7]
    };
    response.result.obj.UserClassManagementList.push(elm);
  });
  return response;
};

const makeOktaInfomationListResponse = (userNmKanji: string): object => {
  const response = {
    status: 'ok',
    message: '処理完了',
    result: {
      obj: {
        OktaInfomationList: [],
      },
    }
  };

  let count = 100;
  if (!PlessViewUtilsSub.isEmpty(userNmKanji) || userNmKanji.length > 3) {
    if (userNmKanji.startsWith('テスト')) {
      count = Number(userNmKanji.slice(3));
    }
  }

  for (let i = Number(0); i < count; i++) {
    const info = {
      UserId: 'UserId' + i,
      // UserNmKanji: '＠＠＠＠＠＠＠＠＠＠ｗｗｗｗｗｗｗｗｗ' + i,
      UserNmKanji: '＠＠＠ ＠＠＠＠' + i,
      // UserDeptNm: '＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠ｗｗｗｗｗｗｗｗｗ' + i,
      UserDeptNm: '＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠＠' + i,
      CrossId: String(i)
    };
    response.result.obj.OktaInfomationList.push(info);
  }
  return response;
};

const makeUpdateUserClassManagementResponse = (params: Array<any>): object => {

  if (params.length > 0) {
    const p = params[0].parameter;

    if (p.ClassCode === '19' && p.GroupLeaderUserId === 'aUser999') {
      return makeSystemError();
    }
    if (p.ClassCode === '19' && p.GroupLeaderUserId === 'aUser888') {
      return makeSessionError();
    }
    if (p.ClassCode === '19' && p.GroupLeaderUserId === 'gUser001') {
      const response = {
        status: 'plessError',
        message: 'ユーザIDは存在しません\n部門: 19、階層: グループ長、ユーザID: gUser001',
        errorcode: 'E0580',
        strings: ['19', 'グループ長', 'gUser001'],
      }
      return response;
    }
    if (p.ClassCode === '19' && p.StaffUserId === 'sUser001') {
      const response = {
        status: 'plessError',
        message: '入力したユーザは既に同一階層に登録されています\n部門: 19、階層: 担当者、ユーザID: sUser001',
        errorcode: 'E0570',
        strings: ['19', '担当者', 'sUser001'],
      }
      return response;
    }
    if (p.ClassCode === '19' && p.AgentUserId === 'aUser001') {
      const response = {
        status: 'plessError',
        message: '上位階層のユーザが登録されていません\n部門: 19、階層: 代行者、ユーザID: aUser001',
        errorcode: 'E0581',
        strings: ['19', '代行者', 'aUser001'],
      }
      return response;
    }
  }
  
  const response = {
    status: 'ok',
    message: '処理完了'
  };
  return response;
};

const makeDeleteUserClassManagementResponse = (params: Array<any>): object => {

  if (params.length > 0) {
    const p = params[0].condition;

    if (p.ClassCode === '19') {
      return makeSystemError();
    }
    if (p.ClassCode === '21') {
      return makeSessionError();
    }
  }

  const response = {
    status: 'ok',
    message: '処理完了'
  };
  return response;
};

const makeGetOktaUserNameResponse = (data: string): object => {
  const response = {
    status: 'ok',
    message: '処理完了',
    result: {
      obj: {
        OktaInfomation: {
          UserNmKanji: data
        }    
      }
    },
  };
  return response;
};

const makeSystemError = (): object => {
  return {
    status: 'error',
    message: 'システムエラーが発生しました。',
  }
};

const makeSessionError = (): object => {
  return {
    status: 'plessError',
    message: 'セッションがタイムアウトしました。再度ログインして下さい。',
    errorcode: 'S0103',
    strings: [],
  };
};